/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_PIPELINE_DATA = (state) => {
    state.loading = true
    state.error = false
}

/**
 * Set the project data on successful retrieval
 *
 * @param  {Object} state
 * @param  {Array} data
 * @return {Void}
 */
const PIPELINE_GET_SUCCESS = (state, data) => {
    state.data = data
    state.loading = false
}

/**
 * Handle the failed data retrieval
 *
 * @param  {Object} state
 * @return {Void}
 */
const PIPELINE_GET_FAILURE = (state) => {
    state.error = true
    state.loading = false
}

/**
 * Remove a project from a pipeline
 *
 * @param  {Object} state
 * @return {Void}
 */
const REMOVE_PROJECT = (state, payload) => {
    let projectIndex = state.data[payload.from].projects.map(project => project.id).indexOf(payload.item.id)

    state.data[payload.from].projects.splice(projectIndex, 1)
}

/**
 * Add a project to a pipeline
 *
 * @param  {Object} state
 * @return {Void}
 */
const ADD_PROJECT = (state, payload) => {
    let item = JSON.parse(JSON.stringify(payload.item))

    state.data[payload.to].projects.splice(payload.newPosition, 0, item)
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Hydrate the project data for a pipeline stage
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Void}
 */
const GET_STAGE_DATA_SUCCESS = (state, data) => {
    state.projects = data
}

const UPDATE_LIST = (state, payload) => {
    state.data[payload.idx].projects = payload.list
}

export default {
    RESET_STATE,
    UPDATE_LIST,
    GET_PIPELINE_DATA,
    PIPELINE_GET_SUCCESS,
    PIPELINE_GET_FAILURE,
    REMOVE_PROJECT,
    ADD_PROJECT,
    GET_STAGE_DATA_SUCCESS
}



// WEBPACK FOOTER //
// ./src/state/modules/deal-pipeline/mutations.js